export class Banner {
    _id: string;
    position: string;
    bannerImageName: string;
    bannerTitle: string;
    bannerImage: string;
    bannerDescription: string;
    link: string;
    bannerSubTitle: string;
    buttonContent: string;
}
